(function ($) {
  $(window).on("load", function () {
    var section = ".col-two-block",
      formWrapClass = ".col-two-block .actual-poll",
      titleClass = ".poll-question";
    if ($('.poll-view.full').length > 0) {
      // append poll form in the section
      var $pollDetail = $(".poll-view.full").html();
      $(".poll-view.full").append('<section class="col-two-block bg-mahogany"> <div class="container"><div class = "column-wrapper d-flex"> <div class="col-two" > <h6>Poll</h6> <h3 class="we-poll-title"></h3></div> <div class="col-two form"> <div class="actual-poll">' + $pollDetail + ' </div</div></div></div></section>');
    }
    if ($(section).length > 0) {
      setTimeout(function () {
        // wraping unwrap text in span
        function wrapText(className){
          var textnodes = getTextNodesIn($(className)[0]);
          for(var i=0; i < textnodes.length; i++){
            if($(textnodes[i]).parent().is(className)){
              $(textnodes[i]).wrap("<span class='unwanted-text'>");
            }
          }
        }
        wrapText(".actual-poll");
        wrapText(".poll-view");
        // apending title in according to the design
        var $titleCont = $(formWrapClass).find(titleClass).text();
        $(formWrapClass).find(titleClass).remove();
        $(".col-two-block .we-poll-title").html($titleCont);
        $(".unwanted-text").remove();
        $(section).css("opacity", "1");
      }, 300);
    }
    // fetching white space/fetching unwrap text
    function getTextNodesIn(node, includeWhitespaceNodes) {
      var textNodes = [], whitespace = /^\s*$/;
      function getTextNodes(node) {
        if (node.nodeType == 3) {
          if (includeWhitespaceNodes || !whitespace.test(node.nodeValue)) {
            textNodes.push(node);
          }
        } else {
          for (var i = 0, len = node.childNodes.length; i < len; ++i) {
            getTextNodes(node.childNodes[i]);
          }
        }
      }
      getTextNodes(node);
      return textNodes;
    }
  });
  $(window).on('load', function () {
    $('.col-two-block label').text(function (index, currentText) {
      if ($(this).text().length > 2000) {
        return currentText.substr(0, 2000) + '...';
      }
    });
  });
})(jQuery);